import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { CmsImageComponent } from './cms-image.component';

@NgModule({
  imports: [CommonModule, MediaModule, CmsImageComponent],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        CMSImageComponent: {
          component: CmsImageComponent,
        },
      },
    }),
  ],
  exports: [CmsImageComponent],
})
export class CmsImageModule {}
